import { LazyMotion, AnimatePresence, domAnimation } from 'framer-motion';
import {
  ComponentType, lazy, Suspense, Fragment,
} from 'react';
import { useSelector } from 'react-redux';

import { useOrientationChange } from '@ezugi/hooks/src/useOrientationChange';

import { BetActionsProps } from '../../features/bet-toolbar/BetActions';
import { canPlaceBetsSelector } from '../../store/selectors';

const DefaultBetActions = lazy(() => import('../../features/bet-toolbar/BetActions'));

type MobileToolbarProps = {
  className?: string;
  hidden?: boolean;
  components?: {BetActions: ComponentType<BetActionsProps>};
}

const MobileToolbar = ({ className, hidden, components }: MobileToolbarProps) => {
  const orientation = useOrientationChange();
  const canPlaceBets = useSelector(canPlaceBetsSelector);
  const vertical = orientation === 'landscape';
  const isHidden = !canPlaceBets || hidden;

  const BetActions = components?.BetActions ?? DefaultBetActions;

  return (
    <Fragment>
      <Suspense fallback={null}>
        <LazyMotion features={domAnimation}>
          <AnimatePresence>
            {!isHidden && (
              <BetActions
                className={className}
                vertical={vertical}
              />
            )}
          </AnimatePresence>
        </LazyMotion>
      </Suspense>
      <div id="mobile-toolbar-extras" style={{ width: '100%' }} />
    </Fragment>
  );
};

export default MobileToolbar;
